import { Component, Vue } from 'vue-facing-decorator';
import { isUserAuth, user } from '@/helpers/auth';
import { EventBus } from '@/utils/EventBus';

const MOBILE_MAX_WIDTH: number = 768;
const TABLET_MAX_WIDTH: number = 1280;

export default {
    methods: {
        requireImage(path: string): any {
            let image = null;
            try {
                image = require(`@/static/images/${path}`);
            } catch (e) {
                console.log(e);
            }
            return image;
        },

        sentNotif(responseOrId: any, isSuccess?: boolean) {
            // @ts-ignore-next-line
            if (responseOrId && responseOrId.status === 404) {
                // @ts-ignore-next-line
                EventBus.$emit(`sent-notification`, this.$i18n.t('ERRORS.404'));
            } else if (responseOrId && responseOrId.status === 401) {
                // @ts-ignore-next-line
                EventBus.$emit(`sent-notification`, this.$i18n.t('ERRORS.401'));
            } else if (responseOrId && responseOrId.status === 403) {
                // @ts-ignore-next-line
                EventBus.$emit(`sent-notification`, this.$i18n.t('ERRORS.403'));
            } else if (responseOrId && responseOrId.status === 500) {
                // @ts-ignore-next-line
                EventBus.$emit(`sent-notification`, this.$i18n.t('ERRORS.500'));
            } else if (!isSuccess && responseOrId && responseOrId.data && responseOrId.data.errors) {
                const error = Array.isArray(responseOrId.data.errors) ? responseOrId.data.errors[0] : responseOrId.data.errors;
                // @ts-ignore-next-line
                EventBus.$emit(`sent-notification`, this.$i18n.t(error));
            } else if (responseOrId) {
                // @ts-ignore-next-line
                EventBus.$emit(`sent-notification`, this.$i18n.t(responseOrId), isSuccess);
            }
        },

        isTablet(): boolean {
            return window.innerWidth < TABLET_MAX_WIDTH && window.innerWidth >= MOBILE_MAX_WIDTH;
        },
        isMobile(): boolean {
            return window.innerWidth < MOBILE_MAX_WIDTH;
        },
        isDesktop(): boolean {
            return window.innerWidth >= MOBILE_MAX_WIDTH;
        },
        // @ts-ignore-next-line
        async requireFwImage(path: string): Promise<any> {
            let image = null;
            try {
                image = await import(`../static/images/${path}`);
            } catch (e) {
                console.log(e);
            }
            return image;
        },
    },

    computed: {
        isUserAuth() {
            return isUserAuth();
        },

        user() {
            return user();
        },

        userId(): null | number {
            // @ts-ignore-next-line
            return this.user ? this.user.id : null;
        },
    },
};
